export default {
    view: "查看更多"
}